import CompanyGroupTableActions from '@/components/company-groups/CompanyGroupTableActions.vue';
import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableTruncate from '@/components/datatable/DataTableTruncate.vue';
import { decodeHtmlEntities } from '@/utils/helpers';
import type { CompanyGroup } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<CompanyGroup>[] = [
    {
        accessorKey: 'id',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'company-groups.table_headers.id',
            }),
        filterFn: 'includesString',
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'company-groups.table_headers.name',
            }),
        cell: ({ row }) => {
            return decodeHtmlEntities(row.original.name || '');
        },
        sortingFn: 'text',
    },
    {
        accessorKey: 'companies_names',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'company-groups.table_headers.companies',
            }),

        cell: ({ row }) => {
            return h(DataTableTruncate, {
                value: row.original.companies_names,
            });
        },
    },
    {
        accessorKey: 'companies_count',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'company-groups.table_headers.count',
            }),
        filterFn: 'includesString',
        meta: {
            filterType: 'number',
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(CompanyGroupTableActions, {
                companyGroup: row.original,
            });
        },
    },
];
